import styled from 'styled-components'
import { colors } from '../../utils/colors'

export const Wrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .leaflet-container {
    flex: 1;
    border-radius: 6px;
    font-family: inherit;
    z-index: 0; /* abaixo dos menus/selects do MUI */
  }

  .leaflet-tooltip {
    font-size: 12px;
    line-height: 1.4;
  }
`

export const SemCoordenada = styled.div`
  font-size: 11px;
  color: ${colors.third};
  line-height: 1.3;
`
